import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../Icons'

import Services from './Services'
import FourBlocksAnalytics from './FourBlocksAnalytics'
import ReservationsAnalytics from './ReservationsAnalytics'

const OperationData = ({ operationData, loading, datesDescriptions }) => {
  const { t } = useTranslation(['building-analytics'])

  return (
    <div className="operation-data">
      <div className="operation-data__header">
        <div className="title-with-icon">
          <Icon
            styles={{ width: '20px', height: '20px' }}
            viewBox="0 0 24 24"
            icon="cog"
            svgProps={{ fillRule: 'evenodd', clipRule: 'evenodd' }}
          />
          <h3>{t('building-analytics:operationData.title')}</h3>
        </div>
        <p>
          {t('building-analytics:common.dateRangeCompared', {
            start: datesDescriptions[0],
            end: datesDescriptions[1],
          })}
        </p>
      </div>
      {loading ? (
        <div className="loading">
          <h3>....</h3>
          <h3>{t('building-analytics:common.loading')}</h3>
        </div>
      ) : (
        <div className="operation-data__main-block">
          <ReservationsAnalytics operationData={operationData} />
          <FourBlocksAnalytics data={operationData} />
          <Services services={operationData ? operationData.services : null} loading={loading} />
        </div>
      )}
    </div>
  )
}

OperationData.propTypes = {
  operationData: PropTypes.object,
  loading: PropTypes.bool,
  datesDescriptions: PropTypes.array,
}
export default OperationData
